import React from 'react';

export const HighlightedText = ({ text, searchTerm }) => {
    if (!searchTerm) return text;
    
    // Convert text to string to handle numeric values
    const textString = text?.toString() || '';
    const searchTermString = searchTerm?.toString() || '';
    
    const index = textString.toLowerCase().indexOf(searchTermString.toLowerCase());
    if (index === -1) return text;
    
    return (
      <>
        {textString.substring(0, index)}
        <span style={{ color: "red" }}>
          {textString.substring(index, index + searchTermString.length)}
        </span>
        {textString.substring(index + searchTermString.length)}
      </>
    );
  };